import { useState } from "react";
import Android from "./Android";
import IOS from "./IOS";
import PC from "./PC";
import PcWin11 from "./PcWin11";
import "./install.css";

const TABS = [
    { key: "android", label: "Android", component: <Android /> },
    { key: "ios", label: "iOS", component: <IOS /> },
    { key: "pc", label: "PC", component: <PC /> },
    { key: "pcwin11", label: "PC (Win11)", component: <PcWin11 /> },
];

export default function Install() {
    const [activeKey, setActiveKey] = useState(TABS[0].key);
    const active = TABS.find((tab) => tab.key === activeKey) ?? TABS[0];

    return (
        <div>
            <h2 className="section-heading">How to install</h2>
            <div className="panel install-panel">
                <div className="install-tabs" role="tablist">
                    {TABS.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            role="tab"
                            aria-selected={tab.key === activeKey}
                            className={`install-tab ${
                                tab.key === activeKey ? "active" : ""
                            }`}
                            onClick={() => setActiveKey(tab.key)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
                <div className="install-body">{active.component}</div>
            </div>
        </div>
    );
}
